module.exports = __webpack_public_path__ + "img/chris_g_33.268a1674.jpg";